import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.setPassword.pageTitle',
    defaultMessage: 'Registrati',
  },
  pageSubtitle: {
    id: 'features.setPassword.pageSubtitle',
    defaultMessage: 'Inserisci la tua nuova password',
  },
  newPassword: {
    id: 'features.setPassword.newPassword',
    defaultMessage: 'Nuova password',
  },
  action: {
    id: 'features.setPassword.action',
    defaultMessage: 'REGISTRATI',
  },
  confirmNewPassword: {
    id: 'features.setPassword.confirmPassword',
    defaultMessage: 'Conferma nuova password',
  },
  newPasswordPlaceholder: {
    id: 'features.setPassword.newPasswordPlaceholder',
    defaultMessage: 'Nuova password',
  },
  confirmNewPasswordPlaceholder: {
    id: 'features.setPassword.confirmNewPasswordPlaceholder',
    defaultMessage: 'Conferma nuova password',
  },
  attemptsDisclaimer: {
    id: 'features.setPassword.confirmNewPasswordPlaceholder',
    defaultMessage:
      'La password che stai per impostare sarà la stessa che utilizzerai per accedere al portale MyAzimut',
  },
});
